/* eslint-disable */
import {
  LDA_TENANT_ID,
  FUNCTION_ROLES,
  THEME_ROLES,
  THEME_META,
  THEME_ORDER,
} from 'src/config/entraIds';
import {THEMES} from "src/config/themes";

function _readGroupsFromUser(user) {
  if (!user) return [];
  const maybe = user?.profile?.groups || user?.id_token?.groups || user?.groups;
  if (Array.isArray(maybe)) return maybe;
  return [];
}

export function isOttoSchmidt(user) {
  return user?.profile?.iss === 'https://online.otto-schmidt.de';
}

export function hasGroup(user, groupId) {
  return _readGroupsFromUser(user).includes(groupId);
}

export function isLdaTenantUser(user) {
  const iss = user?.profile?.iss || '';
  return iss.includes(LDA_TENANT_ID);
}

export function hasApplicationAccess(user) {
  if (!user) return false;
  if (isOttoSchmidt(user)) return true;
  if (isLdaTenantUser(user)) return true;
  return false;
}

export function getPermissions(user) {
  if (!user) {
    return { allRoutes: false, canSearch: false, canChat: false, canCheck: false, canEdit: false, canNKR: false };
  }

  if (isOttoSchmidt(user)) {
    return { allRoutes: true, canSearch: true, canChat: true, canCheck: true, canEdit: true, canNKR: true };
  }

  const canSearch = hasGroup(user, FUNCTION_ROLES.SEARCH);
  const canChat = canSearch;
  const canCheck = hasGroup(user, FUNCTION_ROLES.ANALYSIS);
  const canEdit = hasGroup(user, FUNCTION_ROLES.EDITOR);
  const canNKR = hasGroup(user, FUNCTION_ROLES.NKR);

  return { allRoutes: false, canSearch, canChat, canCheck, canEdit, canNKR };
}

export function hasPermission(perms, required) {
  if (!required) return true;
  if (perms?.allRoutes) return true;
  return !!perms?.[required];
}

export function getAvailableThemes(user) {
  const result = [];
  for (const key of THEME_ORDER) {
    const meta = THEME_META[key];
    if (!meta) continue;
    if (meta.alwaysAvailable) { result.push(key); continue; }
    if (key === THEMES.OTTO_SCHMIDT && isOttoSchmidt(user)) { result.push(key); continue; }
    const roleId = meta.roleId || THEME_ROLES[key];
    if (roleId && hasGroup(user, roleId)) result.push(key);
  }
  return result;
}

export function getDefaultTheme(user) {
  const themes = getAvailableThemes(user);
  const vendorThemes = themes.filter((t) => t !== THEMES.LDA_LIGHT && t !== THEMES.LDA_DARK);
  return vendorThemes.length === 1 ? vendorThemes[0] : THEMES.LDA_LIGHT;
}

